/**
 * Product-level typing. Module/layer ids and the `INswRlgspSystemLayers`
 * envelope are derived from the module/layer table in `layerConfig.ts` —
 * this file only holds the product enum and the specialised feature type.
 */

import type { IFeature as IGenericFeature } from '#lib/types.js';
import type { NswRlgspModule } from './layerConfig';

export enum EProduct {
	NswRlgsp = 'NSW Regional LG Speed Partnership'
}

/** operational feature — generic IFeature parameterised with EProduct + NswRlgspModule. */
export type INswRlgspFeature = IGenericFeature<EProduct, NswRlgspModule>;
